import type {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_TableOptions,
  MRT_RowData,
} from '@ouster/webviz-react-components';

/* 
  Helper to create pagination config for table component
*/
export const createPaginationConfig = <T extends MRT_RowData>(
  meta: { totalCount?: number } | undefined,
  pagination: MRT_PaginationState
): Pick<
  MRT_TableOptions<T>,
  'muiBottomToolbarProps' | 'paginationDisplayMode'
> => ({
  muiBottomToolbarProps: {
    sx: {
      '& .MuiBox-root': {
        left: '0px',
        justifyContent: 'center',
      },
      // Hide pagination when there's only one page or less
      display: (meta?.totalCount ?? 0) <= pagination.pageSize ? 'none' : 'flex',
    },
  },
  paginationDisplayMode: 'pages',
});

/*
  Helper to build the displayColumnDefOptions override for the built-in
  'mrt-row-actions' column, which material-react-table sizes too narrow by
  default and clips whenever a table renders more than one action button.
  Each table's action buttons take up different widths, so `size` should be
  wide enough to fit them all (e.g. ~40px per icon button, more if a labeled
  button or overflow menu is included).
*/
export const getRowActionsColumnOptions = <T extends MRT_RowData>(
  size: number,
  overrides?: Partial<MRT_ColumnDef<T>>
): MRT_TableOptions<T>['displayColumnDefOptions'] => ({
  'mrt-row-actions': {
    size,
    minSize: size,
    maxSize: size,
    enableResizing: false,
    grow: false,
    ...overrides,
  },
});

export const hasUserSelectionOnTable = () => {
  const selection = window.getSelection();
  if (selection && selection.toString().length > 0) {
    return true;
  }

  return false;
};
